import { COLORS } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

export const WRAPPER_PADDING = 127;

export default createStyleSheet({
  column: {
    paddingLeft: WRAPPER_PADDING,
    paddingRight: WRAPPER_PADDING,
    paddingBottom: 94,
    flexDirection: 'column',
    paddingTop: 0,
    height: '100%',
  },
  titleContainer: {
    width: '100%',
  },
  pictureSpotError: {
    display: 'flex',
    alignSelf: 'start',
  },
  pictureSpotContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: COLORS.BLUE_GRAY_LIGHT.DEFAULT,
    paddingTop: 40,
    paddingBottom: 94,
    borderRadius: 8,
  },
  tabsContainer: {
    marginTop: 32,
    backgroundColor: COLORS.BLUE_GRAY_LIGHT.DEFAULT,
    padding: 24,
    borderRadius: 8,
  },
  commonContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  tabs: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
  },
  textAreaBackground: {
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
  switchQuestion: {
    marginRight: 24,
    width: '100%',
  },
  deleteQuestion: {
    marginLeft: 0,
    marginTop: 14,
    marginBottom: 25,
  },
  deleteQuestionDescription: {
    paddingLeft: 20,
    paddingTop: 24,
  },
  modal: {
    height: 189,
  },
});
